import React from 'react';
import Popup from "../../../../components/WMS/Mobile/Popup";
import {ReactComponent as ErrorIcon} from "assets/img/picto-error-404.svg";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../components/CustomButton";

DeleteMissionModal.propTypes = {};

function DeleteMissionModal({open, handleClose, handleValid, loading}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.missionList.deleteModelModal.title"}/>}
            subtitle={<FormattedMessage id={"wms.missionList.deleteModelModal.subtitle"}/>}
            icon={<ErrorIcon/>}
        >
            <Grid container direction={"column"} gap={"8px"}>
                <CustomButton
                    loading={loading}
                    disabled={loading}
                    fullWidth
                    color={"red"}
                    onClick={handleValid}>
                    <FormattedMessage id={"wms.missionList.deleteModelModal.button.delete"}/>
                </CustomButton>
                <CustomButton
                    fullWidth
                    color={"default"}
                    onClick={handleClose}>
                    <FormattedMessage id={"wms.missionList.deleteModelModal.button.cancel"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default DeleteMissionModal;